import script from "./MultiButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiButtons.vue?vue&type=script&lang=ts&setup=true"

import "./MultiButtons.vue?vue&type=style&index=0&id=6e18abba&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e18abba"]])

export default __exports__